import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback, useMemo } from 'react';
import { pauseDeliveryModalStore } from './store/pauseDeliveryModalStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalFooter from 'src/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import ModalContent from '~/view/components/Controls/Modal/ModalContent/ModalContent';

const PauseDeliveryModal: FC = observer((): ReactElement => {
  const { minutes, isValid, updateMinutes } = pauseDeliveryModalStore;

  const modalParams = useMemo(
    () => ({
      onSave: modalStore.pauseDeliveryModal?.onSave,
    }),
    []
  );

  const onPressSave = useCallback(() => {
    if (modalParams.onSave && minutes) modalParams.onSave(Number(minutes));
  }, [minutes]);

  return (
    <CustomModalComponent modalMaxWidth={743} isOpen contentStyle={{ height: 360 }} onRequestClose={modalStore.closePauseDeliveryModal} withCloseIcon>
      <ModalBackground>
        <ModalHeader title={localeStore.t('pause_delivery_popup_hdr')} />
        <ModalContent>
          <Text type={TEXT.SECTION_HEADER} text="pause_delivery_time_title" />
          <InputWithTextInside
            type="number"
            value={minutes}
            onChangeValue={updateMinutes}
            textProps={{ text: 'pause_delivery_time_value' }}
            validation={{
              isValid: pauseDeliveryModalStore.isValid,
            }}
            className="mt-6"
          />
        </ModalContent>
        <ModalFooter>
          <Button
            title={localeStore.t('confirm_paused_delivery_time_button')}
            onClick={onPressSave}
            disabled={!minutes || Number(minutes) === 0 || !isValid}
            size="large"
          />
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});

export default PauseDeliveryModal;
